import AcUnit from "@mui/icons-material/AcUnit";
import Brush from "@mui/icons-material/Brush";
import ChangeHistory from "@mui/icons-material/ChangeHistory";
import Construction from "@mui/icons-material/Construction";
import FlashlightOn from "@mui/icons-material/FlashlightOn";
import GridView from "@mui/icons-material/GridView";
import HolidayVillage from "@mui/icons-material/HolidayVillage";
import Lyrics from "@mui/icons-material/Lyrics";
import Quiz from "@mui/icons-material/Quiz";
import RunCircle from "@mui/icons-material/RunCircle";
import SignLanguage from "@mui/icons-material/SignLanguage";
import Work from "@mui/icons-material/Work";
import Dropdown from "@mui/joy/Dropdown";
import IconButton from "@mui/joy/IconButton";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import React, { SyntheticEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TitleBar() {
  return (
    <header className="absolute flex flex-row justify-between items-center top-0 left-0 h-12 w-full p-4 z-20">
      <PortfolioDropdown />
      <HolidayCardDropdown />
    </header>
  );
}

function PortfolioDropdown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenChange = React.useCallback(
    (event: SyntheticEvent | null, isOpen: boolean) => {
      setOpen(isOpen);
    },
    []
  );

  return (
    <Dropdown open={open} onOpenChange={handleOpenChange}>
      <MenuButton
        slots={{ root: IconButton }}
        slotProps={{ root: { color: "neutral" } }}
      >
        <Construction fontSize="large" />
      </MenuButton>
      <Menu>
        <MenuItem
          onClick={() =>
            window.open("https://www.fantasyfrisbee.com/", "_blank")
          }
        >
          <RunCircle fontSize="medium" /> Fantasy Frisbee
        </MenuItem>
        <MenuItem
          onClick={() => window.open("https://www.workrex.io/", "_blank")}
        >
          <Work fontSize="medium" /> WorkRex
        </MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              "https://chromewebstore.google.com/detail/asl-gifer/ahcdnjickoaigfaaplkfggbohjdofogg?hl=en&pli=1",
              "_blank"
            )
          }
        >
          <SignLanguage fontSize="medium" /> ASL GIFer
        </MenuItem>
        <MenuItem
          onClick={() => window.open("https://fourword.xyz/", "_blank")}
        >
          <GridView fontSize="medium" /> Fourword
        </MenuItem>
        <MenuItem
          onClick={() => window.open("https://www.pyramini.com/", "_blank")}
        >
          <ChangeHistory fontSize="medium" /> Pyramini
        </MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              "https://www.icloud.com/iclouddrive/0a6ry6NAK3HFg9vkjUR3SF6Tg#Morse_code",
              "_blank"
            )
          }
        >
          <FlashlightOn fontSize="medium" /> Morse Code
        </MenuItem>
        <MenuItem
          onClick={() => navigate('/asciiart/video')}
        >
          <Brush fontSize="medium" /> Ascii Art
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}

function HolidayCardDropdown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenChange = React.useCallback(
    (event: SyntheticEvent | null, isOpen: boolean) => {
      setOpen(isOpen);
    },
    []
  );

  return (
    <Dropdown open={open} onOpenChange={handleOpenChange}>
      <MenuButton
        slots={{ root: IconButton }}
        slotProps={{ root: { color: "neutral" } }}
      >
        <HolidayVillage fontSize="large" />
      </MenuButton>
      <Menu>
        <MenuItem onClick={() => navigate("/holidaycard/2024")}>
          2024 Holiday Card <Quiz fontSize="medium" /> 
        </MenuItem>
        <MenuItem onClick={() => navigate("/holidaycard/2023")}>
          2023 Holiday Card <AcUnit fontSize="medium" />
        </MenuItem>
        <MenuItem onClick={() => navigate("/holidaycard/2022")}>
          2022 Holiday Card <Lyrics fontSize="medium" /> 
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}
